import InputMessage from './container'
export { InputMessage }
export default InputMessage